import React from 'react';
import { useTranslation } from 'react-i18next';
import { SetNewPassword } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function SetNewPasswordPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('set-new-password-component.metatags.title'),
        description: t('set-new-password-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.setNewPassword,
        index: false,
    });

    return <SetNewPassword />;
}
